import {Connect} from "@ibm-aspera/connect-sdk-js";

export const connectClient = new Connect( {dragDropEnabled: true});

connectClient.initSession();
